$(document).ready(function () {
    // const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var isMobile = /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
    
    // if (isMobile) {
    if (isMobile && $(window).width() < 1180) {
        const mobileMenu = $('.header__nav .custom-header .bg-white').detach(); 
        const popupNavigation = $('.header__nav .custom-header');
        let interactionHandled = false; // Prevent multiple appends

        // Event handler for touch or scroll
        function handleInteraction() {
            if (interactionHandled) return; // Avoid duplicate execution
            interactionHandled = true;

            popupNavigation.append(mobileMenu);
            console.log('Menu appended to popup-navigation__menu');
        }

        // Attach event listeners (triggered only once)
        $(window).one('scroll touchstart', handleInteraction);
    } else {
        // Desktop View: Remove mobile-specific menus
        if ($('.menu-desktop-none').length > 0 ) {
          $('nav.custom-header, .header__nav .custom-org-menu').remove();
        }
        console.log('Mobile-specific menus removed for desktop');
    }
});

  $(document).ready(function(){
    $(".menu_carousel").slick({infinite:!1,slidesToShow:6,slidesToScroll:6,dots:!1,arrows:!0,responsive:[{breakpoint:1e5,settings:"unslick"},{breakpoint:1100,settings:{slidesToShow:4,slidesToScroll:4,dots:!1}},{breakpoint:480,settings:{slidesToShow:3,slidesToScroll:3,dots:!1}}]})
  });


let hasAppendedHTML = false; // Flag to track if the HTML has been appended

async function fetchAndRenderHTML(url) {
    try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const mainContent = doc.querySelector('main');
        if (!mainContent) {
            throw new Error("No <main> element found in the fetched HTML.");
        }

        const breadcrumbs = mainContent.querySelector('.breadcrumbs');
        if (breadcrumbs) {
            breadcrumbs.remove();
        }

        const container = document.createElement('div');
        container.appendChild(mainContent.cloneNode(true));
        document.body.appendChild(container);

        console.log("HTML rendered successfully!");
    } catch (error) {
        console.error("Error fetching and rendering HTML:", error);
        throw error;
    }
}

function addMultiEventListener(target, events, callback) {
    const handler = async (event) => {
        if (hasAppendedHTML) {
            return; // Prevent further execution if HTML is already appended
        }

        hasAppendedHTML = true; // Set the flag to true to prevent duplication

        try {
            await callback(event);
        } catch (error) {
            console.error("Error in callback:", error);
        }

        // Remove all attached events
        events.forEach((eventType) => target.removeEventListener(eventType, handler));
    };

    // Add all events to the target
    events.forEach((eventType) => target.addEventListener(eventType, handler));
}

// Example Usage
const targetElement = document; // Using the document to listen for global events
const events = ['touchstart', 'click', 'mousemove', 'scroll']; // List of events

if (targetElement) {
    addMultiEventListener(targetElement, events, async () => {
        await fetchAndRenderHTML('https://www.stencilease.com/pages/footer');
    });
}